import * as React from 'react'

import ButtonClear from './ButtonClear'

function MessageBar({ color, children, buttonTitle, onClick, noMargin }) {
  const margin = noMargin ? '' : 'sm:mx-6 mb-8'
  return (
    <div className={`flex justify-center ${margin}`}>
      <div
        className={`flex flex-col items-center bg-${
          color || 'blue'
        }-200 rounded py-2 px-3`}
      >
        <p className="text-gray-500 text-sm text-center">{children}</p>
        {buttonTitle && (
          <ButtonClear className="mt-2 bg-light-40 hover:bg-light-70">
            {buttonTitle}
          </ButtonClear>
        )}
      </div>
    </div>
  )
}

export default MessageBar
